import {createAction, createAsyncThunk} from '@reduxjs/toolkit'

import {PaymentPriorityType, StorageRecoveryType} from '@web/core/constants'
import {removeStorage, SecureStorage} from '@web/helpers/storage'

import {RootState} from './interfaces'
import {getSavedStateFromStorage, saveStateToStorage} from './storage'

type ThunkApi = {
    state: RootState
    rejectValue: string
}

/** 현재 state 정보를 저장합니다 */
export const saveState = createAction('restoreState/saveState')

/** 현재 state 정보를 저장합니다 */
export const asyncSaveState = createAsyncThunk<
    void,
    {
        saverKey: string | string[]
        secureStorageKey?: string
    },
    ThunkApi
>('restoreState/asyncSaveState', ({saverKey, secureStorageKey}, {getState, rejectWithValue}) => {
    const currentState = getState()

    const result = saveStateToStorage({saverKey, secureStorageKey, currentState})

    if (!result) {
        rejectWithValue('can not access session storage')
    }
})

export const rejectMsg = 'no saved state'

/** 전달받은 데이터를 전체 slice에 알려 state를 복구합니다 */
export const restoreSavedState = createAsyncThunk<
    RootState,
    {
        saverKey: string | string[]
        secureStorageKey?: string
    },
    ThunkApi
>('restoreState/restoreSavedState', ({saverKey, secureStorageKey}, {rejectWithValue}) => {
    const saverData = getSavedStateFromStorage<RootState>({saverKey, secureStorageKey})

    if (!saverData) {
        return rejectWithValue(rejectMsg)
    }

    return saverData
})

/** 전달받은 데이터를 slice에 알려 state를 복구합니다 */
export const restoreState = createAction<RootState, string>('restoreState/restore')

/**
 * 결제수단 앱 storage 복원 액션
 * 복원 type에 따라 정책이 달라 기존 action 재사용이 불가하여 일단 복사하여 이관
 * TODO: 추후 개선 필요
 */
export const restoreOrderSheetDataByStorage = createAsyncThunk<
    RootState,
    {
        storage: SecureStorage<RootState>
        type: StorageRecoveryType
        paymentType?: PaymentPriorityType
    },
    ThunkApi
>('restoreOrderSheetDataByStorage', ({storage}) => {
    return {...storage.get({})}
})

export const removeSessionStorage = createAsyncThunk<void, {storageKey: string}, ThunkApi>(
    'removeSessionStorage',
    ({storageKey}) => {
        removeStorage(storageKey)
    },
)
